import React from "react";
import FileDownload from "js-file-download";
import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

// Fetch CalendarEventDetails
export const fetchCalendarEventDetails = async (fileTrackingID, customerId, currentCalendarYear) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/CalenderView/Tracker/FilingdetailsBasedonId?FileTrackingID=${fileTrackingID}&CustomerId=${customerId}&Year=${currentCalendarYear}`
    );
    // console.log("fetchCalendarEventDetails res", res);

    return res.data.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Fetch StaffAssignedList
export const fetchStaffAssignedList = async (
  previousStartDate,
  filingId,
  customerId
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/Customer/CustomerFileTrackingConsolidate?CustomerId=${customerId}&FilingId=${filingId}&PreviousStartDate=${previousStartDate}`
    );
    // console.log("fetchStaffAssignedList res", res);

    return res.data.data;
  } catch (error) {
    // console.log("@@Error:", error);
    throw error;
  }
};

//Update CalendarEventDetails
export const updateCalendarEventDetails = async (payload) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/Customer/CustomerFileTrackingUpdate`,
      payload
    );
    // console.log("updateCalendarEventDetails res", res);

    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    throw error;
  }
};

export const syncCalendarEventPeriodDueDate = async (fileTrackingId) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/Customer/CustomerFilingTrackerPeriodDuedateUpdate/${fileTrackingId}`
    );

    return res.data;
  } catch (error) {
    throw error;
  }
};
